import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";
import _ from "lodash";

import { fetchCurrency, updateCurrency, showLoading, fetchOptions, fetchSettings } from "../../redux/actions";

import { colorTheme } from "../../utils/constants";
import { IonModal, IonHeader, IonToolbar, IonTitle, IonContent, IonSearchbar, IonList, IonItem, IonLabel } from "@ionic/react";

const mapStateToProps = state => {
    return {
        settings: state.settings,
        currency: state.currency,
        options: state.options
    };
}

const mapDispatchToProps = {
    fetchCurrency,
    showLoading,
    fetchOptions,
    fetchSettings,
    updateCurrency
}

class CurrencyDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCurrency: "",
            allowedCurrencies: [],
            dropdownOpen: false,
            searchTerm: ""
        };
    }

    async componentDidMount() {
        await this.fetchInitialData();
        this.setState({
            selectedCurrency: this.props.currency.customerCurrency || "Set Currency",
            allowedCurrencies: this.props.options.allowedCurrencies
        });
    }

    async fetchInitialData() {
        await Promise.all([
            this.fetchSettings(),
            this.fetchOptions(),
            this.fetchCurrency()
        ]);
    }

    async fetchSettings() {
        if (_.isEmpty(this.props.settings)) {
            this.props.showLoading(true);
            await this.props.fetchSettings();
        }
    }

    async fetchOptions() {
        if (_.isEmpty(this.props.options)) {
            this.props.showLoading(true);
            await this.props.fetchOptions();
        }
    }

    async fetchCurrency() {
        if (_.isEmpty(this.props.currency)) {
            this.props.showLoading(true);
            await this.props.fetchCurrency();
        }
    }

    async handleCurrencyChange(currency) {
      await new Promise((resolve) => {
        this.setState(
          {
            selectedCurrency: this.state.allowedCurrencies.find((c) => c === currency)
          },
          resolve
        );
      });
      this.props.showLoading(true);
      await this.props.updateCurrency(this.state.selectedCurrency[0]);
    }

    toggleDropdown() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    render() {
        const { selectedCurrency, dropdownOpen, allowedCurrencies, searchTerm } = this.state;
        const displaySelected = Array.isArray(selectedCurrency)
          ? `${selectedCurrency[1]} (${selectedCurrency[0]})`
          : selectedCurrency || "Set Currency";
        const filteredCurrencies = (allowedCurrencies || []).filter((c) => {
          const code = (c && c[0] ? String(c[0]) : "").toLowerCase();
          const name = (c && c[1] ? String(c[1]) : "").toLowerCase();
          const term = (searchTerm || "").toLowerCase();
          return code.includes(term) || name.includes(term);
        });

        return (
          <Row className='mx-1 my-2'>
            <Col xs={12} lg={12} className=''>
              <div
                onClick={() => this.toggleDropdown()}
                style={{ borderColor: colorTheme["primary"]["700"], border: "2px solid grey", borderRadius: "10px", padding: "12px", cursor: "pointer" }}
              >
                <span>{displaySelected}</span>
              </div>

              <IonModal isOpen={dropdownOpen} onDidDismiss={() => this.toggleDropdown()}>
                <IonHeader>
                  <IonToolbar>
                    <IonTitle>Select Currency</IonTitle>
                  </IonToolbar>
                </IonHeader>
                <IonContent>
                  <div className='px-3 py-2'>
                    <IonSearchbar
                      value={searchTerm}
                      debounce={150}
                      placeholder="Search by code or name"
                      onIonInput={(e) => this.setState({ searchTerm: e.detail.value })}
                    />
                  </div>
                  <IonList>
                    {filteredCurrencies.map((currency) => (
                      <IonItem
                        key={currency[0]}
                        button
                        onClick={async () => {
                          await this.handleCurrencyChange(currency);
                          this.setState({ dropdownOpen: false, searchTerm: "" });
                        }}
                      >
                        <IonLabel>{`${currency[1]} (${currency[0]})`}</IonLabel>
                      </IonItem>
                    ))}
                  </IonList>
                </IonContent>
              </IonModal>
            </Col>
          </Row>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CurrencyDropdown);
